import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

// Define the shape of an alert object
interface Alert {
    id?: string;
    type?: string;
    message?: string;
    msgtimeout?: number;
    isShowSwal?: boolean;
}

// Typed Subject for alerts
const alertSubject = new Subject<Alert>();
const defaultId = 'default';
const timeout = 3000; // Default timeout for alerts

const autoClose = true; 
const keepAfterRouteChange = false;
const msgOptions = { autoClose, keepAfterRouteChange };

//rxjs alert service for show alerts across applications
export const alertService = {
    onAlert,
    success,
    error,
    info,
    warn,
    alert,
    clear,
};
//alert types
export const alertType = {
    success: 'success',
    error: 'error',
    info: 'info',
    warning: 'warning'
}

// Listen for alerts with a specific ID
function onAlert(id = defaultId) {
    return alertSubject.asObservable().pipe(
        filter((x: Alert) => x && x.id === id)
    );
}

function success(message: string, msgtimeout: number = timeout, isShowSwal: boolean = false) {
    alert({ ...msgOptions, type: alertType.success, message, msgtimeout, isShowSwal });
}

function error(message: string, msgtimeout: number = timeout, isShowSwal: boolean = false) {
    alert({ ...msgOptions, type: alertType.error, message, msgtimeout, isShowSwal });
}

function info(message: string, msgtimeout: number = timeout, isShowSwal: boolean = false) {
    alert({ ...msgOptions, type: alertType.info, message, msgtimeout, isShowSwal });
}

function warn(message: string, msgtimeout: number = timeout, isShowSwal: boolean = false) {
    alert({ ...msgOptions, type: alertType.warning, message, msgtimeout, isShowSwal });
}

function alert(alert: { id?: string, type?: string, message?: string, msgtimeout?: number, isShowSwal?: boolean }) {
    alert.id = alert.id || defaultId;
    alertSubject.next(alert);
}

function clear(id = defaultId) {
    alertSubject.next({ id });
}